<template>
  <div :class="'gallery autoplay items-' + slider.length">
    <div v-for="(slide, key) in slider" :id="'item-' + key" class="control-operator"></div>

    <figure class="item" v-for="slide in slider" style="margin:0;">
      <img v-lazy="slide" style="width:100%;">
    </figure>

    <div class="controls">
      <a v-for="(slide, key) in slider" :href="'#item-' + key" class="control-button" style="line-height:1;">•</a>
    </div>
  </div>
</template>

<script>
  import './../../assets/css/slider.css'
  export default {
    data() {
      return {
        topSide: true,
      }
    },
    computed: {
      slider() {
        return this.$store.state.slider;
      }
    },
    mounted() {
      $(function () {
        $(window).scroll(function () {
          var nav = $('#navs').innerHeight();
          var carousel = $('.gallery').innerHeight();
          var fixmenu = $('#fixmenu').height();
          var cartWidth = $('#cartWidth').width();
          var carviewheight = fixmenu;
          var tops = nav + carousel;
          var clientHeight = screen.height;
          var cartBottom = $('.cartBottom').height();
          var cartTitle = $('.cartTitle').height();
          var ffootter = $('.ffootter').height();
          var top = $(document).scrollTop();
          var cartProductHeight = clientHeight - cartBottom - cartTitle - ffootter - fixmenu;
          var vm = this;
          if (top < tops) {

            if (!vm.topSide) {
              $("#fixmenu").css({
                top: '0',
                position: 'relative',
                background: 'transparent',
              });
              $('#cartview').css({
                top: '0',
                position: 'relative',
                width: '100%',
              });
              $('.bg-cat').css({
                marginTop: '0px',
              });
              vm.topSide = true;
            }

          } else {

            if (vm.topSide) {
              $("#fixmenu").css({
                top: '0',
                position: 'fixed',
                background: 'rgb(44,49,52, 0.9)',
                zIndex: '999',
                width: '100%'
              });
              $("#cartview").css({
                top: carviewheight + 40 + 'px',
                position: 'fixed',
                width: cartWidth + 'px',
              });
              $('.bg-cat').css({
                marginTop: fixmenu + 'px',
              });
              if (cartBottom) {
                $('.fix').css({
                  maxHeight: cartProductHeight - (cartProductHeight * 0.55) + 'px',
                });
              }
              vm.topSide = false;
            }

          }

        });
      });
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/Home/slider.vue